import { magicNumbers } from 'utils';

export const contentInitialState = {
  onreloadContents: 1,
  contents: {
    multiPlatform: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    news: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    instagram: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    instagramComment: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    instagramCommentByPost: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    telegram: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    twitter: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    virasty: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    newspaper: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    nativePlatforms: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
    linkedin: {
      data: [],
      loading: true,
      loadingCount: true,
      error: null,
      total: 0,
      pageNumber: 1,
    },
  },
  expandedIndex: magicNumbers.DEFAULT_EXPANDED_ITEM_INDEX,
  isExpanded: false,
  isUpOrDownKeyClicked: false,
  resultSearchQuery: {
    multiPlatform: '',
    news: '',
    instagram: '',
    instagramComment: '',
    instagramCommentByPost: '',
    telegram: '',
    twitter: '',
    virasty: '',
    newspaper: '',
    nativePlatforms: '',
    linkedin: '',
  },
  selectedContents: [],
  currentContentId: undefined,
  reportUnrelatedPost: {
    data: [],
    loading: true,
    error: null,
  },
  updatePostSentiment: {
    data: {},
    error: null,
  },
  twitterAggregateInfo: {
    data: null,
    loading: false,
    error: null,
  },
  markPostAsSeen: {
    loading: false,
    error: null,
  },
};
